import {Component, Element, Fragment, h, Host, Method, Prop} from "@stencil/core"
import {TileClass, TileSizesType} from "./constants"
import {govHost} from "../../helpers/Dom/template"
import {GovHost} from "../../helpers/Dom/template.types"
import {ButtonTargetType} from "../gov-button/button/constants"

@Component({
	tag: "gov-tile",
})
export class GovTile {
	@Element() host: HTMLGovTileElement
	/**
	 * Tile’s size
	 */
	@Prop({reflect: true}) readonly size?: TileSizesType = "m"
	/**
	 * Style variation of the tile.
	 */
	@Prop() readonly orientation: "vertical" | "horizontal"
	/**
	 * Tiles border
	 */
	@Prop({ attribute: 'no-border' }) readonly noBorder: boolean = false
	/**
	 * Link on whole tile
	 */
	@Prop({reflect: true}) readonly href: string
	/**
	 * Same as original parameter
	 * @link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target
	 */
	@Prop() readonly target?: ButtonTargetType
	private triggerRef?: HTMLLinkElement | HTMLSpanElement
	private h: GovHost

	constructor() {
		this.h = govHost(this.host)
	}

	render() {
		return (
			<Host class={this.h.classes(TileClass.root)}
				  size={this.size}
				  orientation={this.orientation}
				  clickable={this.href ? true : null}
			>
				<slot name="icon"/>
				<div class={TileClass.content}>
					<div class={TileClass.text}>
						<div class={TileClass.title}>
							{this.href ? (
								<Fragment>
									<a
										href={this.href}
										target={this.target}
										class={TileClass.link}
										ref={el => (this.triggerRef = el as HTMLLinkElement | HTMLSpanElement)}>
										<slot name="title"/>
									</a>
									<span class={TileClass.icon}>
										<gov-icon name="chevron-right" type="components"></gov-icon>
									</span>
								</Fragment>
							) : (
								<slot name="title"/>
							)}
						</div>
						<div class={`${TileClass.annotation} ${this.href ? `${TileClass.annotation}--padding` : ''}`}>
							<slot/>
						</div>
					</div>
					<slot name="button"/>
				</div>
			</Host>
		)
	}

	/**
	 * Returns a clickable element instance
	 */
	@Method()
	async getTriggerRef() {
		return this.triggerRef
	}
}
